export default {"src":"/_next/static/media/discord-black.4ee03f1d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};